module.exports = __webpack_public_path__ + "img/sabre_logo.63e56478.png";